// CELL-BIO9 — REP / INTEL / MUSCLE / HEAT readout + day counter.

import type { GameState } from "../engine/gameState";

export function initStatBar(root: HTMLElement, state: GameState): void {
  const render = (s: GameState): void => {
    root.textContent = "";

    const day = document.createElement("span");
    day.className = "stat day";
    day.textContent = `DAY ${s.day}`;
    root.appendChild(day);

    const stats: Array<[string, number, string]> = [
      ["REP", s.rep, "rep"],
      ["INTEL", s.intel, "intel"],
      ["MUSCLE", s.muscle, "muscle"],
      ["HEAT", s.heat, "heat"],
    ];
    for (const [label, value, cls] of stats) {
      const el = document.createElement("span");
      el.className = `stat ${cls}`;
      el.textContent = `${label} ${String(value).padStart(2, "0")}`;
      root.appendChild(el);
    }
  };

  state.onChange(render);
  render(state);
}